import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import { FlagOn, FlagOff } from '../../FeatureFlag/FeatureFlag'
import Button from '../../Button/Button'

import '../ConfirmPage.css'

export const BackToMenuButton = ({ getRestaurantPath }) => (
  <Link styleName='backToMenu' to={getRestaurantPath()}>
    <FlagOff name='oo-v3-loyalty'>
      <div styleName='wrapper'>
        <Button
          data-testid='back-to-menu-button'
          style='primary'
          responsive
        >
          Back To Menu
        </Button>
      </div>
    </FlagOff>
    <FlagOn name='oo-v3-loyalty'>
      <div styleName='backToMenuWrapper'>
        <Button
          data-testid='back-to-menu-button'
          style='link'
          responsive
        >
          Back To Menu
        </Button>
      </div>
    </FlagOn>
  </Link>
)

BackToMenuButton.propTypes = {
  getRestaurantPath: PropTypes.func.isRequired
}
